import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "../lib/notify";
import { KeyRound } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState(""); const [p1, setP1] = useState(""); const [p2, setP2] = useState("");
  const forced = !!user?.must_change_password;
  const submit = async (e) => {
    e.preventDefault();
    if (p1.length < 6) return toast.error("Şifre en az 6 karakter olmalı");
    if (p1 !== p2) return toast.error("Şifreler eşleşmiyor");
    try { await http.post("/auth/change-password", { current_password: cur, new_password: p1 }); toast.success("Şifreniz güncellendi"); await refresh?.(); navigate(user?.role === "taseron" ? "/is-emirleri" : "/dashboard"); } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="max-w-md mx-auto mt-10 bg-white border border-slate-200 rounded-lg p-6 space-y-4" data-testid="page-change-password">
      <div className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-orange-600" /><h1 className="text-xl font-bold text-slate-900">Şifre Değiştir</h1></div>
      {forced && <div className="text-xs bg-amber-50 border border-amber-200 text-amber-800 rounded-md p-2" data-testid="cp-forced">Geçici şifre ile giriş yaptınız. Devam etmek için yeni bir şifre belirleyin.</div>}
      <form onSubmit={submit} className="space-y-3">
        {!forced && <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Mevcut şifre" data-testid="cp-current" className="w-full px-3 py-2 text-sm border border-slate-300 rounded-md" />}
        <input type="password" value={p1} onChange={(e) => setP1(e.target.value)} placeholder="Yeni şifre (en az 6 karakter)" data-testid="cp-new" className="w-full px-3 py-2 text-sm border border-slate-300 rounded-md" />
        <input type="password" value={p2} onChange={(e) => setP2(e.target.value)} placeholder="Yeni şifre (tekrar)" data-testid="cp-new2" className="w-full px-3 py-2 text-sm border border-slate-300 rounded-md" />
        <button type="submit" data-testid="cp-save" className="w-full px-3 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800">Şifreyi Kaydet</button>
      </form>
    </div>
  );
}
